export default "__VITE_ASSET__f2d74416__"